import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from '../hooks/useTranslation'
import logo from '../assets/logo.png'
import { getFlagImageUrl } from './LanguageFlags'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [langMenuOpen, setLangMenuOpen] = useState(false)
  const location = useLocation()
  const { t, lang, setLanguage, locales, data } = useTranslation()

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/services', label: t('nav.services') },
    { path: '/about', label: t('nav.about') },
    { path: '/contact', label: t('nav.contact') },
  ]

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  const handleLanguageChange = (newLang) => {
    setLanguage(newLang)
    setLangMenuOpen(false)
  }

  const handleNavClick = (path) => {
    setMobileMenuOpen(false)
    setLangMenuOpen(false)
    window.scrollTo(0, 0)
  }

  // 从翻译数据中获取语言名称
  const getLanguageName = (code) => {
    if (data && data.lang && data.lang[code]) {
      return data.lang[code]
    }
    const defaultNames = {
      en: 'English',
      fr: 'Français',
      pt: 'Português',
      es: 'Español',
      zh: '简体中文',
      'zh-HK': '繁體中文',
      mn: 'Монгол',
      ko: '한국어',
      ja: '日本語',
      vi: 'Tiếng Việt'
    }
    return defaultNames[code] || code
  }

  // 获取语言对应的国旗
  const getLanguageFlag = (code) => {
    return getFlagImageUrl(code)
  }

  return (
    <header className="header">
      <div className="container header-content">
        <Link to="/" className="logo">
          <img src={logo} alt="CCICM" style={{ height: '50px', width: 'auto' }} />
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => handleNavClick(link.path)}
            >
              {link.label}
            </Link>
          ))}

          {/* 移动端语言切换 - 在菜单内 */}
          <div className="lang-switcher-mobile">
            <button
              className="lang-btn"
              onClick={() => setLangMenuOpen(!langMenuOpen)}
            >
              <img
                src={getFlagImageUrl(lang)}
                alt={`${lang} flag`}
                className="lang-flag"
                style={{ width: 24, height: 16, objectFit: 'cover', borderRadius: 2 }}
              />
              <span>{getLanguageName(lang)}</span>
              <span className="lang-arrow">▼</span>
            </button>

            {langMenuOpen && (
              <div className="lang-dropdown">
                {locales.map((locale) => (
                  <button
                    key={locale}
                    onClick={() => handleLanguageChange(locale)}
                    className={lang === locale ? 'active' : ''}
                  >
                    <img
                      src={getFlagImageUrl(locale)}
                      alt={`${locale} flag`}
                      className="lang-flag"
                      style={{ width: 30, height: 20, objectFit: 'cover', borderRadius: 2 }}
                    />
                    <span>{getLanguageName(locale)}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </nav>

        {/* 桌面端语言切换 - 靠右 */}
        <div className="lang-switcher lang-switcher-desktop">
          <button
            className="lang-btn"
            onClick={() => setLangMenuOpen(!langMenuOpen)}
          >
            <img
              src={getFlagImageUrl(lang)}
              alt={`${lang} flag`}
              className="lang-flag"
              style={{ width: 24, height: 16, objectFit: 'cover', borderRadius: 2 }}
            />
            <span>{getLanguageName(lang)}</span>
            <span className="lang-arrow">▼</span>
          </button>

          {langMenuOpen && (
            <div className="lang-dropdown">
              {locales.map((locale) => (
                <button
                  key={locale}
                  onClick={() => handleLanguageChange(locale)}
                  className={lang === locale ? 'active' : ''}
                >
                  <img
                    src={getFlagImageUrl(locale)}
                    alt={`${locale} flag`}
                    className="lang-flag"
                    style={{ width: 30, height: 20, objectFit: 'cover', borderRadius: 2 }}
                  />
                  <span>{getLanguageName(locale)}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => {
            setMobileMenuOpen(!mobileMenuOpen)
            setLangMenuOpen(false)
          }}
          aria-label="菜单"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* 点击外部关闭菜单 */}
      {langMenuOpen && (
        <div
          className="menu-overlay"
          onClick={() => {
            setLangMenuOpen(false)
            setMobileMenuOpen(false)
          }}
        />
      )}
    </header>
  )
}
